import { LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";

interface HeaderProfileProps {
  onSignOut: () => Promise<void>;
}

export function HeaderProfile({ onSignOut }: HeaderProfileProps) {
  return null; // Component no longer renders anything
}